import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import { Dispatch, SetStateAction } from 'react'

const ActiveDeactiveDialogConfirmation = ({ active, changeStatus, onCancel, deletedoc}: { active?: boolean,  onCancel: Function,changeStatus: Function , deletedoc ?: boolean}) => {

    const footerContent = (
        <div>
            <Button label="No" icon="pi pi-times" onClick={() => onCancel()} className="p-button-text" />
            <Button label="Yes" icon="pi pi-check" onClick={() => changeStatus()} autoFocus />
        </div>
    );


    return (
        // <Dialog draggable={false} modal visible={visible} onHide={() => { onHide(false) }} footer={footerContent}>
        //     <p className="text-center">
        //         <b style={{ wordBreak: "break-all" }}>Are you sure you want to {!active ? "De-Active" : "Active"} this?</b>
        //     </p>
        // </Dialog>

        <div>
            <div className="modal fade" id="active-deactive" aria-labelledby="statusModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content bg-white">
                        <div className="modal-body pt-4 pb-3 text-center main-msg">
                            <p className='mb-0'>{deletedoc
                                ? "Are you sure you want to delete this?"
                                : `Are you sure you want to ${active ? "Active" : "Inactive"} this?`}</p>
                        </div>
                        <div className="modal-footer justify-content-center border-top-0 pb-4">
                            <button type="button" className="grey-outline-btn mr-3"  data-bs-dismiss="modal" onClick={() => onCancel()}>No</button>
                            <button type="button" className="outline-icon-btn" data-bs-dismiss="modal" onClick={() => changeStatus()}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default ActiveDeactiveDialogConfirmation